
import { Sparkles, Lightbulb } from "lucide-react";

const DreamHeader = () => {
  return (
    <div className="flex flex-col space-y-2">
      <h1 className="text-3xl font-bold tracking-tight flex items-center">
        <Sparkles className="h-8 w-8 mr-2 text-primary" /> Dream & Ideate
      </h1>
      <p className="text-muted-foreground">
        Explore and develop your business ideas through curated content, interactive tools, AI assistance, and visual inspiration.
      </p>
      <div className="flex items-center text-sm text-muted-foreground mt-1">
        <Lightbulb className="h-4 w-4 mr-1 text-amber-500" />
        <span>Use the Ideation Tools to visually map out your concepts and ideas.</span>
      </div>
    </div>
  );
};

export default DreamHeader;
